export default __webpack_public_path__ + "static/char-56-anr-90a0e0d715a817f6ee242553e0d66d41.gif";